<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="idx"
      :headers="headers"
      :items="datiMostrati"
      :options.sync="options"
      :server-items-length="totaleDati"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Importazione prodotti da file Excel (esegue anche i movimenti di carico a magazzino)</v-toolbar-title>
      </v-toolbar>
      <parametri
        :loading="isImportaProdotti"
        :loading-categorie="isAggiornaCategorie"
        @changeModello="onChangeModello"
        @importa="importaProdotti"
        @onLoaded="onLoaded"
        @cambiaVista="cambiaVista"
        @aggiornaCategorie="aggiornaCategorie"
        />
    </template>
    <template v-slot:no-data>
      Imposta il modello e carica un file Excel
    </template>
    </v-data-table> 
    <v-dialog
      v-model="isImportaProdotti"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Importazione prodotti in corso
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import Parametri from './components/parametri'
  import categorie from '@/services/categorieService'
  import configurazioni from '@/services/configurazioniService.js'
  import { creaMovimenti, creaMovimentiSoloNonPresenti } from './tipi/prodotti.js'
  import _ from 'lodash'
  
  export default {
    components: {
      Parametri
    },
    mixins: [verificaLicenza],
    data () {
      return {
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        mostaRaw: false,
        datiRaw: [],
        datiModello: [],
        totaleDati: 0,
        intestazioniRaw: [],
        intestazioniModello: [],
        isImportaProdotti: false,
        isAggiornaCategorie: false,
        modelloItem: null
      }
    },
    created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
    },
    async mounted() {
      await this.verificaModuliLocali()
    },
    computed: {
      formTitle () {
        return 'Importazione prodotti da file Excel' // modificare in base al modello
      },
      datiMostrati() {
        let dati = this.mostaRaw ? this.datiRaw : this.datiModello
        dati = dati.map((x, idx) => { return { idx, ...x } })
        const opz = this.options
        return _.take(_.drop(dati, (opz.page - 1) * opz.itemsPerPage), opz.itemsPerPage)
         
      },
      headers() {
        return this.mostaRaw ? this.creaHeaders(this.intestazioniRaw) : this.creaHeaders(this.intestazioniModello)
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleMovimenti = _.sum(elSel.map(x => x.qtaMovimenti))
          return { totaleAnagrafica, totaleMovimenti }
        } else {
          return { totaleAnagrafica: 0, totaleMovimenti: 0 }
        }
      }
    },
    watch: {
      options: {
        async handler () {
          this.loading = false
        },
        deep: true
      }
    },
    methods: {
      backClick() {
        this.$emit('back')
      },
      onChangeModello(modello) {
        this.modelloItem = modello
      },
      onLoaded(dati) {
        if (!dati) {
          this.datiRaw = []
          this.datiModello = []
          this.totaleDati = 0
          this.intestazioniModello = []
          this.intestazioniRaw = []
          return
        }
        this.datiRaw = dati.datiRaw
        this.datiModello = dati.datiModello
        this.totaleDati = dati.datiRaw.length
        this.intestazioniModello = dati.intestazioniModello
        this.intestazioniRaw = dati.intestazioniRaw
      },
      cambiaVista(value) {
        this.mostaRaw = value
      },
      creaHeaders(colonne, dati) {
        const hd = []
        for (let c of colonne) {
          const hh = { text: c.value, value: c.key }
          hd.push(hh)
        }
        return hd
      },
      async importaProdotti(infoImport) {
        if (this.totaleDati > 0 && this.modelloItem) {
          this.isImportaProdotti = true
          const dati = this.selected.length > 0 ? this.selected : this.datiModello
          const usaTagliaColore = this.modelloItem['usa_taglia_colore'] !== undefined ? this.modelloItem['usa_taglia_colore'] : true
          console.log('usaTagliaColore', usaTagliaColore)
          if (infoImport.soloNonPresenti) {
            await creaMovimentiSoloNonPresenti(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, infoImport.riferimento, infoImport.fornitore, infoImport.data, infoImport.fornitoreSuColonne, usaTagliaColore, infoImport.magazzino)
          } else {
            await creaMovimenti(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, infoImport.riferimento, infoImport.fornitore, infoImport.data, infoImport.fornitoreSuColonne, usaTagliaColore, infoImport.magazzino)
          }
          
          // this.prodottiImportati = true
          this.isImportaProdotti = false

          if (infoImport.aggiornaCategorie) {
            await this.aggiornaCategorie()
          }
          this.annullaSelezione()
        }
      },
      async aggiornaCategorie() {
        if (this.modelloItem && this.modelloItem.creaCategorie) {
          this.isAggiornaCategorie = true
          for (const cat of this.modelloItem.creaCategorie) {
            await categorie.generaCategoria(cat.nomeConfigurazione, cat.subCategoria, cat.tipo, cat.nomeCampoSorgente)
          }
          this.isAggiornaCategorie = false
        }
      },
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      } 
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
